
import axios from "axios";
import { ToastService } from "./toast.service";
import { store } from "../store";
import { TokenService } from "./storage.service";

axios.interceptors.request.use(function (config) {
    config.headers["Content-Type"] = "application/json";
    config.headers.Authorization = `Bearer ${TokenService.getToken()}`;
    // Do something before request is sent
    NProgress.start()
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

function createResponseInterceptor() {
    // Add a response interceptor
    const interceptor = axios.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        NProgress.done()

        return response;
    }, async function (error) {
        NProgress.done()
        if (error.response) {
            // ignore refresh as long as view is login
            if (window.location.href.includes("login")) return Promise.reject(error.response.data);

            let { message, isOp = false } = error.response.data
            let { status } = error.response

            if (status === 401) {
                // Auto refresh token
                axios.interceptors.response.eject(interceptor);
                const originalConfig = error.config;

                try {
                    const response = await store.dispatch("auth/refreshToken");
                    originalConfig.headers = { ...originalConfig.headers };
                    originalConfig.headers["Authorization"] = `Bearer ${response.data.accessToken}`;

                    const originalResponse = await axios(originalConfig);
                    return originalResponse;
                } catch (error) {
                    return Promise.reject(error);
                } finally {
                    NProgress.done()
                    createResponseInterceptor()
                }
            } else {
                handleError(error.response.data);
            }
        }
        else if (error.request) {
            ToastService.error('', 'No se estableció conexión con el servidor.')
        } else {
            return Promise.reject(error);
        }
    });
}

function handleError(error) {
    if (error.message) {
        ToastService.error("", error.message);
    } else {
        ToastService.error("", 'Error desconocido');
    }

    // return Promise.reject(error);
}

createResponseInterceptor()


// WEBPACK FOOTER //
// ./src/services/createResponseInterceptor.js